import { mockEdd } from '@/__mocks__';
import { individualApi } from '@/apis';

export default {
  /**
   *
   * @param {Function} commit
   * @param {Function} dispatch
   * @param {String} individualId
   */
  async initEddForm({ commit, dispatch }, individualId) {
    commit('reset');
    commit('setLoading', true);
    const requests = [
      dispatch('fetchQuestionnaire', individualId),
      dispatch('fetchStates'),
    ];
    await Promise.all(requests);
    dispatch('setupEdd');
    commit('setLoading', false);
  },
  /**
   *
   * @param {Function} commit
   * @param {Object} rootGetters
   * @param {String} individualId
   */
  async fetchQuestionnaire({ commit, rootGetters }, individualId) {
    const token = rootGetters['auth/token'];
    try {
      const response = await individualApi.requestCurrentQuestionnaire({
        token,
        individualId,
      });
      commit('setQuestionnaire', response.data.questionnaire_master_data);
    }
    catch (error) {
      commit('setError', error);
    }
  },
  /**
   *
   * @param {Function} commit
   * @param {Object} rootGetters
   */
  async fetchStates({ commit, rootGetters }) {
    const token = rootGetters['auth/token'];
    try {
      const response = await individualApi.requestCddEddState(token);
      commit('setStates', response.data);
    }
    catch (error) {
      commit('setError', error);
    }
  },
  /**
   *
   * @param {Function} commit
   * @param {Object} getters
   */
  setupEdd({ commit, getters }) {
    const questionnaire = getters.questionnaire;
    if (questionnaire.edd) {
      commit('setEdd', JSON.parse(questionnaire.edd));
      return;
    }
    const edd = mockEdd();
    commit('setEdd', edd);
    commit('setCustomer', {
      id: questionnaire.individual_id,
      fullname: questionnaire.fullname,
      address: questionnaire.address,
      city: questionnaire.city,
      province: questionnaire.province,
      state: questionnaire.state,
    });
  },
  /**
   *
   * @param {Function} commit
   * @param {String} sectionId
   * @param {String} id
   * @param {Boolean} value
   */
  saveSectionValue({ commit }, { sectionId, id, value }) {
    commit('setSectionValue', { sectionId, id, value });
  },
  /**
   *
   * @param {Function} commit
   * @param {Object} getters
   */
  async saveEddForm({ commit, getters, rootGetters }, eddStateId) {
    commit('setSaving', true);
    const token = rootGetters['auth/token'];
    const questionnaireId = getters.questionnaire.id;
    const data = {
      edd: JSON.stringify(getters.edd),
      edd_state_id: eddStateId,
    };
    try {
      await individualApi.requestAssignEdd({
        token,
        questionnaireId,
        data,
      });
      return true;
    }
    catch (error) {
      commit('setError', error);
      return false;
    }
    finally {
      commit('setSaving', false);
    }
  },
};
